<nav class="navbar navbar-expand-lg bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="">
      <img alt="logo" src="./../../../assets/images/common/home_page_logo.svg">
    </a>
    <button aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"
            data-bs-target="#navbarSupportedContent" data-bs-toggle="collapse" type="button">
      <!-- <span class="navbar-toggler-icon"></span> -->
      <!-- <mat-icon>menu</mat-icon> -->
      <img alt="" class="menu-img" src="../../../assets/images/common/menu.svg">
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        
      </ul>

      <div class="right_container">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a (click)="redirectPricing()" class="nav-link pricing">Pricing</a>
          </li>
          <li class="nav-item">
            <a (click)="redirectContactUs()" class="nav-link pricing">Contact Us</a>
          </li>
          <li *ngIf="srcWidth > 475" class="nav-item">
            <div class="vr_line"></div>
          </li>
          <li class="nav-item">
            <a (click)="loginPage()" class="nav-link signin">Sign in</a>
          </li>
          <li class="nav-item">
            <button (click)="redirectToBType()" class="signup_btn">
              Generate Website
            </button>
          </li>
          <!-- <li class="nav-item">
              <button class="signup_btn" (click)="signUp()">
                  Sign up
              </button>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</nav>
